function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerLocaleKeys from '../../../../locales/keys';
import { ConvergentBillerCurrencyCodeSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { NOT_SHARED } from './policy.counter.thumbnail.constants';
var PolicyCounterThumbnailController = /*#__PURE__*/function () {
  function PolicyCounterThumbnailController($ngRedux) {
    _classCallCheck(this, PolicyCounterThumbnailController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      NOT_SHARED: NOT_SHARED
    });
  }
  return _createClass(PolicyCounterThumbnailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currencyCode: ConvergentBillerCurrencyCodeSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget)(function (state) {
        _this.state = state;
      });
      this.infoTooltipTemplate = require('./templates/info.tooltip.template.html');
      this.viewPolicyDetailsColumnDefs = [{
        field: 'Status',
        displayName: i18n.translate(CustomerLocaleKeys.POLICY_COUNTERS.POLICY_STATUS),
        cellTemplate: require('./cellTemplates/status.template.html'),
        cellClass: 'u-p0'
      }, {
        field: 'Description',
        displayName: i18n.translate(CustomerLocaleKeys.POLICY_COUNTERS.DESCRIPTION)
      }, {
        field: 'Threshold',
        displayName: i18n.translate(CustomerLocaleKeys.POLICY_COUNTERS.ALLOCATION),
        cellTemplate: require('./cellTemplates/threshold.template.html')
      }];
      this.viewPolicyDetailsPopUp = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.viewPolicyDetailsPopUpApi = api;
        }
      };
      this.openViewPolicyDetailsPopup = function (selectedPolicyCounter) {
        _this.selectedPolicyCounter = selectedPolicyCounter;
        _this.viewPolicyDetailsPopUpApi.open();
      };
      this.closeViewPolicyDetailsPopup = function () {
        _this.selectedPolicyCounter = {};
        _this.viewPolicyDetailsPopUpApi.close();
      };
    }
  }]);
}();
export default {
  bindings: {
    policyCounterDetails: '<?'
  },
  controller: PolicyCounterThumbnailController,
  controllerAs: 'PolicyCounterThumbnailController',
  template: require('./policy.counter.thumbnail.template.html')
};